import { render, staticRenderFns } from "./SupplierPage.vue?vue&type=template&id=39b02bc1&"
import script from "./SupplierPage.vue?vue&type=script&lang=js&"
export * from "./SupplierPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports